

const registerDetailsReducer = (state = {"contracts":{},"offers":{},"contractDetails":{},"currentPlanDetails":{},"activeServiceName":"","isContinueInstallation":true,"subscriptions":{"addons":[],"devices":[],"basePlan":[]},"accessDeviceDetails":{"accessDevicesArray":[],"allPOP":[]},"jackDetails":{"freeJackInstallation":{"display":false},"freeJackActivation":{"display":false},"extraJackInstallation":{"display":false},"extraJackActivation":{"display":false}},"wizardType":"NA","isGlobalLoading":false,"isConfirmationPageReached": false,"isSummaryPageReached": false,"isPendingModalDisplay":true,"services": [], "customize": { "addons": [], "devices":[],"serviceOptions": {} , "returnDevice":[]}, "customerInfo": {"updateCustomerDetails":{},"identityDetails":[]}, "billingInfo": {},"OptionalNotifications":[], "installation": {},"confirmation":{}, "voiceDetails":{"directoryDetails":{}},"telNumList":[],"givenAddress": {}, "summary":{},"generalResponse":{"deliveryAddress":{},"planComparisonData":{"currentAddonDetails": [],"oldCartDetails": [], "oldCartDetailsDevices": []},"jackSubscriptions":[],"isSlotReserved":false,"isJackAdded":false,"technicianReservedDate":"","upcHeaders":{},"allTaxDetails":{},"isVoiceServiceActivated":false,"stateList":[],"contextParameters":[],"depositAmount":"","depositAmountChargeCode":"","isDepositAmountRequired":false,"productFamily":[],"installationDetails":[],"pendingOrder":false,"orderId":"","viewOrderResponse":{},"cartlevelDiscountData":[],"cartDiscountSubscription":[]},"finalAddressArrayList":[],"allDeposits" : [],"activeAddons":[]}, action) => {
	if (action.type === 'SET_REGISTER_DETAILS') {
		var newState = {};
		Object.assign(newState, state);
		// newState[action.key] = action.payload;
		insertDataIntoGivenPath(newState,action.key,action.payload);
		console.log("registerDetails newState >>", newState);
		return newState;
	} else {
		return state
	}
}

function insertDataIntoGivenPath(obj, props, newValue) {
	var propsArr = props.split('.');
	var prop = propsArr.splice(0, 1);
	var nextObject = obj[prop];
	if (!propsArr.join('.')) {
		return obj[prop] = newValue;
	} else {
		insertDataIntoGivenPath(nextObject, propsArr.join('.'), newValue);
		return obj;
	}
}

export default registerDetailsReducer;
